import { render, staticRenderFns } from "./CreateProjectDetailAssistant.vue?vue&type=template&id=f1ca0a46&scoped=true&lang=pug&"
import script from "./CreateProjectDetailAssistant.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectDetailAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProjectDetailAssistant.vue?vue&type=style&index=0&id=f1ca0a46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ca0a46",
  null
  
)

export default component.exports